// eslint-disable-next-line import/prefer-default-export
export const calculateRemainingPages = (pageNumbers, currentPage) => {
  if (pageNumbers.length === 0) {
    return 0;
  }
  // Find the index of the currentPage if it exists in the array
  let index;
  if (pageNumbers.includes(currentPage)) {
    index = pageNumbers.indexOf(currentPage);
  } else {
    // If currentPage is not in the array, find the closest page number,
    // it might be that the page is a loader page for example
    const closestPage = pageNumbers.reduce((prev, curr) =>
      Math.abs(curr - currentPage) < Math.abs(prev - currentPage) ? curr : prev
    );
    index = pageNumbers.indexOf(closestPage);
  }

  const remainingPages = pageNumbers.length - index - 1;
  return remainingPages;
};
